import { LocationVarKey } from "@swivl-mono/types";

import { IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { PageHeader, SectionHeader, SwitchRow, TextAreaRow, TextRow } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.ProblemWebIssue1,
  LocationVarKey.ProblemWebIssue2,
  LocationVarKey.WantsBotInitiatedEscalationsWebIssues
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Web Issues
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ProblemWebIssue1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.ProblemWebIssue2}
        enableSwitchVar={LocationVarKey.ProblemWebIssue2Enabled}
      />

      <SectionHeader
        {...page}
        subheading="If a bot is unable to resolve a web issue with basic troubleshooting, turning this on will escalate the conversation to a human team member. This will only apply to complex web issues that are beyond the bot's ability to handle. The bot will still manage straightforward items like forgotten passwords."
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1")}
      >
        Bot-initiated Escalation
      </SectionHeader>
      <TextRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1")}></TextRow>
      <SwitchRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1")}
        keyName={LocationVarKey.WantsBotInitiatedEscalationsWebIssues}
        label="Escalate to Human"
      />
    </>
  );
}
